<div class="cg-page">

  <!-- Header -->
  <div class="cg-header">
    <div>
      <h1 class="cg-title">{{ isAdmin ? 'All Contractors' : 'My Sub-Contractors' }}</h1>
      <p class="cg-subtitle" *ngIf="!isLoading">
        {{ filtered.length }} of {{ contractors.length }} {{ isAdmin ? 'contractors' : 'sub-contractors' }}
        <span *ngIf="tradeFilter"> · {{ tradeFilter }}</span>
      </p>
    </div>
    <button mat-raised-button color="primary" (click)="addContractor()">
      <mat-icon>add</mat-icon> {{ isAdmin ? 'Add Contractor' : 'Add Sub-Contractor' }}
    </button>
  </div>

  <!-- Search + trade filter row -->
  <div class="cg-filter-row" *ngIf="!isLoading && contractors.length > 0">
    <mat-form-field appearance="outline" class="cg-search-field">
      <mat-label>Search contractors</mat-label>
      <mat-icon matPrefix>search</mat-icon>
      <input matInput [(ngModel)]="searchTerm" (ngModelChange)="onSearch()" placeholder="Name, trade, email...">
      <button mat-icon-button matSuffix *ngIf="searchTerm" (click)="searchTerm=''; onSearch()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <!-- Trade type chips -->
    <div class="cg-trade-chips" *ngIf="uniqueTrades.length > 0">
      <span class="cg-trade-label">Filter by trade:</span>
      <button
        *ngFor="let trade of uniqueTrades"
        class="cg-trade-chip"
        [class.cg-trade-chip--active]="tradeFilter === trade"
        (click)="setTradeFilter(trade)">
        {{ trade }}
      </button>
      <button class="cg-trade-chip cg-trade-chip--clear" *ngIf="tradeFilter" (click)="setTradeFilter('')">
        <mat-icon>close</mat-icon> Clear
      </button>
    </div>
  </div>

  <!-- Loading skeletons -->
  <div class="cg-grid" *ngIf="isLoading">
    <div class="cg-skeleton" *ngFor="let i of [1,2,3,4,5,6]">
      <div class="sk-avatar"></div>
      <div class="sk-lines">
        <div class="sk-line sk-line-long"></div>
        <div class="sk-line sk-line-med"></div>
        <div class="sk-line sk-line-short"></div>
      </div>
    </div>
  </div>

  <!-- Error -->
  <div class="cg-empty" *ngIf="loadError && !isLoading">
    <mat-icon>error_outline</mat-icon>
    <p>Failed to load contractors.</p>
    <button mat-stroked-button (click)="loadContractors()">Retry</button>
  </div>

  <!-- Empty state -->
  <div class="cg-empty" *ngIf="!isLoading && !loadError && contractors.length === 0">
    <mat-icon>engineering</mat-icon>
    <p>{{ isAdmin ? 'No contractors yet.' : 'No sub-contractors yet.' }}</p>
    <button mat-raised-button color="primary" (click)="addContractor()">
      <mat-icon>add</mat-icon> {{ isAdmin ? 'Add First Contractor' : 'Add First Sub-Contractor' }}
    </button>
  </div>

  <!-- No search/filter results -->
  <div class="cg-empty" *ngIf="!isLoading && contractors.length > 0 && filtered.length === 0">
    <mat-icon>search_off</mat-icon>
    <p *ngIf="searchTerm && !tradeFilter">No contractors match "{{ searchTerm }}"</p>
    <p *ngIf="tradeFilter && !searchTerm">No contractors with trade "{{ tradeFilter }}"</p>
    <p *ngIf="searchTerm && tradeFilter">No contractors match your search and trade filter</p>
    <button mat-stroked-button (click)="searchTerm=''; tradeFilter=''; applyFilter()">Clear filters</button>
  </div>

  <!-- Contractor cards -->
  <div class="cg-grid" *ngIf="!isLoading && filtered.length > 0">
    <div class="cg-card" *ngFor="let c of filtered; trackBy: trackById">

      <div class="cg-card-top">
        <!-- Avatar -->
        <div class="cg-avatar-wrap">
          <img
            [src]="imageUrl(c.id)"
            loading="lazy"
            class="cg-avatar-img"
            (error)="avatarFallback($event)"
            alt="{{ c.name }}">
          <div class="cg-avatar-initials">{{ initials(c.name) }}</div>
        </div>

        <div class="cg-card-info">
          <div class="cg-name">{{ c.name }}</div>
          <div class="cg-job-title-badge" *ngIf="c.jobTitle">{{ c.jobTitle }}</div>
          <div class="cg-job-title" *ngIf="!c.jobTitle">—</div>
        </div>

        <button mat-icon-button class="cg-edit-btn" (click)="editContractor(c)" matTooltip="Edit">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button class="cg-delete-btn" color="warn" (click)="deleteContractor(c)" matTooltip="Delete">
          <mat-icon>delete</mat-icon>
        </button>
      </div>

      <div class="cg-card-details">
        <a class="cg-detail-row" href="tel:{{ c.cellPhone }}" *ngIf="c.cellPhone">
          <mat-icon>phone</mat-icon>
          <span>{{ c.cellPhone | phoneFilter }}</span>
        </a>
        <div class="cg-detail-row" *ngIf="c.email">
          <mat-icon>email</mat-icon>
          <span>{{ c.email }}</span>
        </div>
        <div class="cg-pay-row">
          <div class="cg-detail-row" *ngIf="c.hourlyWage">
            <mat-icon>schedule</mat-icon>
            <span>{{ c.hourlyWage | currency }}/hr</span>
          </div>
          <div class="cg-detail-row" *ngIf="c.salary">
            <mat-icon>payments</mat-icon>
            <span>{{ c.salary | currency }}/yr</span>
          </div>
        </div>
      </div>

    </div>
  </div>

</div>
